import React from "react";
import { Code } from "lucide-react";
import { CODE_ICON_SIZE } from "../../constants";

/**
 * Empty state component when no file is selected
 * @returns {JSX.Element} The empty state
 */
const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-ui-text-secondary px-4">
      <Code size={CODE_ICON_SIZE} className="mb-4 text-neutral-400" />
      <p className="text-center text-sm sm:text-base">Select a file to view its contents</p>
    </div>
  );
};

export default EmptyState;
